import { defineStore } from "pinia";
export const useLoginStore = defineStore("loginStore", {
  state: () => ({
    user: {},
    loggedIn: false,
  }),
  getters: {
    getUser(state) {
      return state.user;
    },
    getLoggedIn(state) {
      return state.loggedIn;
    },
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    setLoggedIn(loggedIn) {
      this.loggedIn = loggedIn;
    },
  },
  persist: true,
});
